var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileSettings03 = function SvgProfileSettings03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F172A",
    strokeWidth: 1.125,
    d: "M11.625 9a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F172A",
    strokeWidth: 1.125,
    d: "M15.593 6.864c.605 1.042.907 1.563.907 2.136s-.302 1.094-.907 2.136l-1.443 2.487c-.602 1.038-.903 1.557-1.399 1.842-.495.285-1.096.285-2.298.285H7.547c-1.202 0-1.803 0-2.298-.285s-.797-.804-1.4-1.842l-1.442-2.487C1.802 10.094 1.5 9.573 1.5 9s.302-1.094.907-2.136L3.85 4.377c.602-1.038.903-1.557 1.399-1.842.495-.285 1.096-.285 2.298-.285h2.906c1.202 0 1.803 0 2.298.285s.797.804 1.4 1.842z"
  })));
};
export default SvgProfileSettings03;